import type { ReactNode } from "react";
import { useAuth } from "../lib/auth";
import { ForbiddenState } from "./States";

type RequirePermissionProps = {
  permission?: string;
  anyOf?: string[];
  children: ReactNode;
};

export function RequirePermission({
  permission,
  anyOf,
  children,
}: RequirePermissionProps) {
  const { can, canAny } = useAuth();

  const allowed = permission
    ? can(permission)
    : anyOf
      ? canAny(...anyOf)
      : true;

  if (!allowed) {
    return (
      <ForbiddenState
        message={
          permission
            ? `Your role does not include the "${permission}" permission.`
            : "Your role does not include access to this section."
        }
      />
    );
  }

  return <>{children}</>;
}
